const resultSubmittedScreenMessages = {
    resultsSubmitted : 'Your test results have been submitted.',
    moreInformation : 'For more information and the latest guidance on the coronavirus, visit ',  
    backToHome : 'Back to Home',
    viewTestTimeline : 'View test timeline',
};

export default resultSubmittedScreenMessages;